import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import OrganizationFormFields from "@/pages/organizations/organization-form-fields";
import { handleDrawerSuccess, hasArrayErrors, hasMatchingId } from "@/lib/drawer-submission";
import { organization_path, organizations_path } from "@/routes";

export default function OrganizationDrawerForm({ organization = {}, errors = [], onSuccess, onProcessingChange = null }) {
  const isEdit = Boolean(organization.id);
  const { data, setData, post, patch, processing, transform } = useForm({
    name: organization.name || "",
    cvr: organization.cvr || "",
    address: organization.address || "",
    zip: organization.zip || "",
    city: organization.city || "",
    country_code: organization.country_code || "DK",
    phone: organization.phone || "",
    website: organization.website || "",
    logo: null,
    remove_logo: false
  });

  useEffect(() => {
    setData({
      name: organization.name || "",
      cvr: organization.cvr || "",
      address: organization.address || "",
      zip: organization.zip || "",
      city: organization.city || "",
      country_code: organization.country_code || "DK",
      phone: organization.phone || "",
      website: organization.website || "",
      logo: null,
      remove_logo: false
    });
  }, [organization, setData]);

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const submit = async (event) => {
    event.preventDefault();
    transform((values) => ({ organization: values }));

    if (isEdit) {
      patch(organization_path(organization.id), {
        forceFormData: true,
        preserveScroll: true,
        onSuccess: (page) => handleDrawerSuccess(
          page,
          (props) => (
            props.show_edit_organization_drawer ||
            (
              hasArrayErrors(props, "edit_errors") &&
              hasMatchingId(props, "edit_organization", organization.id)
            )
          ),
          onSuccess
        )
      });
      return;
    }

    post(organizations_path(), {
      forceFormData: true,
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => props.show_create_organization_drawer || hasArrayErrors(props, "create_errors"),
        onSuccess
      ),
    });
  };

  return (
    <form id="organization-drawer-form" className="vstack gap-4" onSubmit={submit}>
      {errors.length > 0 ? (
        <div className="alert alert-danger mb-0">{errors.join(", ")}</div>
      ) : null}

      <OrganizationFormFields data={data} setData={setData} logoUrl={organization.logo_url} />

      <div className="d-flex justify-content-end">
        <button type="submit" className="btn btn-primary" disabled={processing}>
          {processing ? (isEdit ? "Gemmer..." : "Opretter...") : (isEdit ? "Gem ændringer" : "Opret organisation")}
        </button>
      </div>
    </form>
  );
}
